import axios from 'axios';
import { history } from '../routers/AppRouter';
import { EXPENSE_ACCOUNTS_ENDPOINT } from '../api/api';

export const FETCH_EXPENSE_ACCOUNTS_SUCCESS = 'FETCH_EXPENSE_ACCOUNTS_SUCCESS';
export const ADD_EXPENSE_ACCOUNT = 'ADD_EXPENSE_ACCOUNT';
export const EXPENSE_ACCOUNT_LOAD_ERROR = 'EXPENSE_ACCOUNT_LOAD_ERROR';
export const EXPENSE_ACCOUNT_LOADING = 'EXPENSE_ACCOUNT_LOADING';
export const EDIT_EXPENSE_ACCOUNT = 'EDIT_EXPENSE_ACCOUNT';

export const expenseAccountLoading = () => {
  return ({
    type: EXPENSE_ACCOUNT_LOADING
  });
};


export const startFetchExpenseAccounts = () => {
  return async (dispatch) => {
    try {
      const expenseAccount = await axios({
        method: 'get',
        url: `${EXPENSE_ACCOUNTS_ENDPOINT}`,
        headers: JSON.parse(sessionStorage.user)
      });
      dispatch(fetchExpenseAccountsSuccess(expenseAccount.data));
    } catch (error) {
      console.log(error.message);
    }
  };
};

const fetchExpenseAccountsSuccess = (expense_accounts) => ({
  type: FETCH_EXPENSE_ACCOUNTS_SUCCESS,
  expense_accounts
});


export const addExpenseAccount = (expenseAccount) => {
  console.log(expenseAccount);
  return ({
    type: ADD_EXPENSE_ACCOUNT,
    expenseAccount
  });
};

export const startAddExpenseAccount = (expenseAccountData = {}) => {
  return async (dispatch) => {
    try {
      dispatch(expenseAccountLoading());
      let expenseAccount = await axios({
        method: 'post',
        url: EXPENSE_ACCOUNTS_ENDPOINT,
        headers: JSON.parse(sessionStorage.user),
        data: expenseAccountData
      });
      return dispatch(addExpenseAccount({
        ...expenseAccount.data
      }), history.push('/cashier'));
    } catch (err) {
      if (err.response && err.response.status === 422) {
        return dispatch(expenseAccountLoadError({ errMessage: err.response.data.message }));
      }
      return dispatch(expenseAccountLoadError({ errMessage: 'Please check your connection and try again' }));
    }
  };
};


const expenseAccountLoadError = (errMessage) => ({
  type: EXPENSE_ACCOUNT_LOAD_ERROR,
  errMessage
});


export const editExpenseAccount = (id, updates) => {
  return ({
    type: EDIT_EXPENSE_ACCOUNT,
    id,
    updates
  });
}

export const startEditExpenseAccount = (id, updates) => {
  console.log(id);
  return async (dispatch) => {
    try {
      // const entry = await axios.put(`${ENTRIES_ENDPOINT}/${id}`, updates);
      let expenseAccount = await axios({
        method: 'patch',
        url: `${EXPENSE_ACCOUNTS_ENDPOINT}/${id}`,
        headers: JSON.parse(sessionStorage.user),
        data: updates
      });
      console.log(expenseAccount);
      return dispatch(editExpenseAccount(expenseAccount.data.id, expenseAccount.data), history.push('/cashier'));
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 422) {
        return dispatch(expenseAccountLoadError({ errMessage: err.response.data.message }));
      }
      return dispatch(expenseAccountLoadError({ errMessage: 'Please check your connection and try again' }));
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/expenseAccountActions.js